export default "__VITE_ASSET__5a62cd5a__"